import { Coord } from "../../types/Interface";

export default function calcDistanceBtwPoints(point1: Coord, point2: Coord) {
  return Math.sqrt((Math.pow(point1.x - point2.x, 2) + Math.pow(point1.y - point2.y, 2)));
}